class BalanceEstimate extends HTMLElement {
  constructor() {
    super();

    const calculateBalanceButton = this.querySelector('.calculate-balance-button');
    this.productHandles = [];
    this.totalDiscountedValue = 0;
    const quantityButtons = this.querySelectorAll('.quantity');

    quantityButtons.forEach((element) => {
      element.addEventListener('change', () => {
        if (Array.from(this.querySelectorAll('.quantity__input')).some((input) => parseInt(input.value, 10) > 0)) {
          calculateBalanceButton.removeAttribute('disabled');
        } else {
          calculateBalanceButton.setAttribute('disabled', 'disabled');
        }
      })
    });

    calculateBalanceButton.addEventListener('click', () => {
      Array.from(this.querySelectorAll('.quantity__input')).forEach((input) => {
        const quantity = parseInt(input.value, 10);
        if (!quantity) return;

        this.productHandles.push(input.closest('.quantity').dataset.productHandle);
        const discountedPrice = parseFloat(input.closest('.quantity').dataset.discountedPrice) * quantity;
        this.totalDiscountedValue += (isNaN(discountedPrice) ? 0 : discountedPrice);
      })

      if (this.totalDiscountedValue === 0 || this.productHandles.length === 0) return;

      sessionStorage.setItem('kitSuggestions', JSON.stringify(this.productHandles));
      sessionStorage.setItem('discountBalance', this.totalDiscountedValue.toFixed(2));
      window.location.href = '/pages/kits-recomendados';
    });
  }
}

customElements.define('balance-estimate', BalanceEstimate);